import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IsAuthenticatedGuard } from 'app/guards/is-authenticated.guard';
import { DevPlaygroundComponent } from '../dev-playground/dev-playground.component';
import { DevPlaygroundGuard } from '../guards/dev-playground.guard';
import { EntitlementsGuard } from '../guards/entitlements.guard';
import { FeatureFlagGuard } from '../guards/feature_flag.guard';
import { IsStaffGuard } from '../guards/is-staff.guard';
import { NotKioskModeGuard } from '../guards/not-kiosk-mode.guard';
import { UserHasRequiredRoleGuard } from '../guards/user-has-required-role.guard';
import { MainPageComponent } from '../main-page/main-page.component';
import { ENTITLEMENTS } from '../services/entitlements.service';
import { FLAGS } from '../services/feature-flag.service';

const routes: Routes = [
	{
		path: '',
		component: MainPageComponent,
		children: [
			{ path: '', redirectTo: 'passes', pathMatch: 'full' },
			{ path: 'passes', loadChildren: () => import('app/passes/passes.module').then((m) => m.PassesModule), canActivate: [NotKioskModeGuard] },
			{
				path: 'hallmonitor',
				loadChildren: () => import('app/hall-monitor/hall-monitor.module').then((m) => m.HallMonitorModule),
				canActivate: [NotKioskModeGuard, IsStaffGuard, UserHasRequiredRoleGuard],
				data: { required_roles: ['access_hall_monitor'] },
			},
			{
				path: 'passes-calendar',
				loadChildren: () => import('app/passes-calendar/passes-calendar.module').then((m) => m.PassesCalendarModule),
				canActivate: [NotKioskModeGuard],
			},
			{
				path: 'activities',
				loadChildren: () => import('app/activities/activities.module').then((m) => m.ActivitiesModule),
				canActivate: [NotKioskModeGuard, IsStaffGuard, FeatureFlagGuard, EntitlementsGuard],
				data: { feature_flag: FLAGS.ActivityManagement, entitlement: ENTITLEMENTS.Flex },
			},
			{
				path: 'kioskMode',
				loadChildren: () => import('app/kiosk-mode/kiosk-mode.module').then((m) => m.KioskModeModule),
				canActivate: [IsStaffGuard],
			},
			{
				path: 'student/:id',
				loadChildren: () => import('app/student-snapshot-page/student-snapshot-page.module').then((m) => m.StudentSnapshotPageModule),
				canActivate: [NotKioskModeGuard, IsStaffGuard],
			},
			{
				path: 'refer_us',
				loadChildren: () => import('app/referrals/referrals.module').then((m) => m.ReferralsModule),
				canActivate: [IsStaffGuard, FeatureFlagGuard],
				data: { feature_flag: FLAGS.RenewalChecklist },
			},
			{
				path: 'classes',
				loadChildren: () => import('app/shared/classes/classes.module').then((m) => m.ClassesModule),
				canActivate: [IsStaffGuard, FeatureFlagGuard, NotKioskModeGuard],
				data: { feature_flag: FLAGS.Schedules },
			},
			{ path: 'dev-playground', canActivate: [IsAuthenticatedGuard, DevPlaygroundGuard], component: DevPlaygroundComponent },
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class MainRoutingModule {}
